import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Details } from './components';
import useTemplate from './useTemplate';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: theme.spacing(3)
  }
}));

const SurveyTemplateDetails = props => {
  const { className, staticContext, ...rest } = props;
  const template = useTemplate();
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.content}>
        <Details
          template={template}
          showNav={true}
          next="/surveyResultResponse-templates/design"
        />
      </div>
    </div>
  );
};

export default SurveyTemplateDetails;
